import { get } from 'lodash-es';

import { emptyObject } from 'ui-components/default-props/empty';

export const selectFreightShipments = (state) => get(state, 'freightShipments', emptyObject);
export const selectFreightShipmentById = (state, props) => get(selectFreightShipments(state), props.freightShipmentId);
export const selectFreightShipmentByFulfillmentPlanId = (state, props) => {
  const shipments = selectFreightShipments(state);
  return Object.values(shipments).find((s) => String(s.fulfillmentPlanId) === String(props.fulfillmentPlanId));
};
